import React from 'react';
import PropTypes from 'prop-types'

const EditNameDefinition = props => {
  return (
    <div
      className="autocode-editname-definition"
      data-test="definitionEditNameComponent"
    >
      <button type="button" onClick={props.onEditName}>
        Edit Name
      </button>
    </div>
  );
};

EditNameDefinition.propTypes = {
  onEditName: PropTypes.func,
}

export default EditNameDefinition;
